// SuccessState.jsx — confirmación tras un aporte exitoso.

import React from 'react'
import { fmtCLP } from '../shared.jsx'

function SuccessState({ amount, method, onReset }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, textAlign: "center", padding: "24px 8px" }}>
      <svg width="64" height="64" viewBox="0 0 64 64" style={{ margin: "0 auto", display: "block" }}>
        <circle cx="32" cy="32" r="30" fill="var(--gold)" />
        <path d="M 18 32 L 28 42 L 46 22" stroke="#0b0a08" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div>
        <h3 style={{ fontFamily: "var(--display)", fontSize: 28, margin: 0, textTransform: "uppercase", lineHeight: 1 }}>
          ¡Gracias!
        </h3>
        <p style={{ fontSize: 14, color: "var(--fg-mute)", margin: "12px auto 0", maxWidth: 280 }}>
          Tu aporte de <b style={{ color: "var(--fg)" }}>${fmtCLP(amount)}</b> nos ayuda a llegar más alto.
          {method === "transfer" && (
            " Tu aporte se verá reflejado cuando consolidemos con el banco que la transferencia llegó."
          )}
        </p>
      </div>
      <button className="btn btn-ghost btn-sm" type="button" onClick={onReset}>
        Hacer otro aporte
      </button>
    </div>
  );
}

export { SuccessState };
